export interface VideoChapter {
  title: string;
  startTime: number;
}

export interface VideoEndScreen {
  type: "VIDEO" | "PLAYLIST" | "SUBSCRIBE";
  targetId?: string;
  startTime: number;
  x: number;
  y: number;
  width: number;
  height: number;
  targetVideo?: {
    id: string;
    title: string;
    thumbnailUrl?: string;
    thumbnail?: string;
    duration?: string;
  };
  channel?: {
    id: string;
    name: string;
    handle: string;
    avatarUrl?: string;
  };
}

export interface VideoItem {
  id: string;
  uid?: string;
  title: string;
  creatorName: string;
  creatorHandle: string;
  creatorAvatar?: string;
  channelId?: string;
  channel_id?: string;
  userId?: string;
  user_id?: string;
  viewsCount: string;
  uploadDate: string;
  createdAt?: string;
  duration: string;
  thumbnailUrl: string;
  thumbnail?: string;
  thumbnail_url?: string;
  custom_thumbnail?: string;
  streamMediaId: string;
  stream_uid?: string;
  hlsManifestUrl: string;
  playbackUrl?: string;
  videoUrl?: string;
  category: "Music" | "Podcasts" | "Tech" | "Entertainment" | "Cinema" | "African Cinema" | "Gaming" | "Culture & News";
  description: string;
  visibility?: "public" | "unlisted" | "private" | "members_only" | "paywalled" | "SCHEDULED" | "scheduled" | "premiere" | string;
  scheduledPublishAt?: string | null;
  isPublished?: boolean;
  releaseType?: "STANDARD" | "PREMIERE" | "LIVE_BROADCAST";
  premiereStatus?: "SCHEDULED" | "COUNTDOWN" | "LIVE" | "COMPLETED";
  scheduledStartTime?: string | null;
  premiereCountdownSeconds?: number;
  thumbnailType?: "AUTO" | "CUSTOM";
  customThumbnailUrl?: string;
  is_paywalled?: boolean;
  rental_price?: number;
  currency?: string;
  status?: string;
  videoType?: "LONG" | "SHORT";
  aspectRatio?: "16:9" | "9:16";
  relatedVideoId?: string | null;
  relatedTimestampSeconds?: number | null;
  relatedVideo?: {
    id: string;
    title: string;
    thumbnailUrl?: string;
    thumbnail?: string;
    duration?: string;
    hlsManifestUrl?: string;
  } | null;
  hasChapters?: boolean;
  chapters?: VideoChapter[];
  endScreens?: VideoEndScreen[];
  abExperiment?: {
    id: string;
    metric: string;
    status: string;
    winningVariantId?: string | null;
    variants: Array<{
      id: string;
      label: string;
      thumbnailUrl: string;
      customTitle?: string | null;
      impressions?: number;
      clicks?: number;
      watchTimeSec?: number;
    }>;
  } | null;
  views?: number;
  likesCount?: number;
  comments_count?: number;
  likes_percentage?: number;
  publishedAt?: string;
  isLive?: boolean;
  liveViewerCount?: number;
  streamKey?: string;
  rtmpIngestUrl?: string;
  srtIngestUrl?: string;
  is360?: boolean;
  is_360?: boolean;
  projectionType?: "EQUIRECTANGULAR" | "FLAT" | string;
  projection_type?: "EQUIRECTANGULAR" | "FLAT" | string;
  meta?: {
    customThumbnail?: string;
    thumbnailUrl?: string;
    name?: string;
    category?: string;
    description?: string;
    [key: string]: any;
  };
}

export const SEED_VIDEOS: VideoItem[] = [
  {
    id: "vid_001",
    title: "HP - Helix Adaptive HLS Streaming Showcase",
    creatorName: "HP - Helix Streaming Engine",
    creatorHandle: "@helixcreator",
    creatorAvatar: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=150&auto=format&fit=crop&q=80",
    viewsCount: "128.4K views",
    uploadDate: "2 hours ago",
    duration: "10:34",
    thumbnailUrl: "https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=800&auto=format&fit=crop&q=80",
    streamMediaId: "helix-demo-stream-001",
    hlsManifestUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    category: "Tech",
    description: "Experience low-latency multi-bitrate HLS streaming with high-fidelity audio and adaptive video delivery across all devices.",
  },
  {
    id: "vid_002",
    title: "Accra Tech Summit: Building Scalable Cloud Infrastructure",
    creatorName: "Tech In Africa",
    creatorHandle: "@techinafrica",
    creatorAvatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80",
    viewsCount: "45.2K views",
    uploadDate: "1 day ago",
    duration: "18:45",
    thumbnailUrl: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800&auto=format&fit=crop&q=80",
    streamMediaId: "accra-tech-2026",
    hlsManifestUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    category: "Tech",
    description: "Keynote presentation at Accra Tech Summit exploring serverless edge architectures, Postgres connection pooling, and CDN video edge delivery.",
  },
  {
    id: "vid_003",
    title: "Afrobeats Fusion Live Concert: Lagos Nights 2026",
    creatorName: "AfroSound Studio",
    creatorHandle: "@afrosound",
    creatorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80",
    viewsCount: "310.8K views",
    uploadDate: "3 days ago",
    duration: "24:10",
    thumbnailUrl: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=800&auto=format&fit=crop&q=80",
    streamMediaId: "afrobeats-lagos-live",
    hlsManifestUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    category: "Music",
    description: "High-definition 4K performance featuring top Afrobeats artists live from Lagos Sound Arena.",
  },
  {
    id: "vid_004",
    title: "The Future of African Cinema & Digital Monetization",
    creatorName: "Nollywood Pulse",
    creatorHandle: "@nollywoodpulse",
    creatorAvatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80",
    viewsCount: "89.1K views",
    uploadDate: "4 days ago",
    duration: "15:20",
    thumbnailUrl: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&auto=format&fit=crop&q=80",
    streamMediaId: "african-cinema-future",
    hlsManifestUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    category: "Cinema",
    description: "In-depth panel discussion on direct creator payout models, mobile money tipping, and global film distribution.",
  },
  {
    id: "vid_005",
    title: "Deep Tech Podcast: AI & Mobile Money in West Africa",
    creatorName: "Fintech Horizon",
    creatorHandle: "@fintechhorizon",
    creatorAvatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80",
    viewsCount: "67.4K views",
    uploadDate: "5 days ago",
    duration: "32:05",
    thumbnailUrl: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=800&auto=format&fit=crop&q=80",
    streamMediaId: "fintech-podcast-ep12",
    hlsManifestUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    category: "Podcasts",
    description: "Exploring automated n8n webhook reconciliation for MTN MoMo, Vodafone Cash, AirtelTigo, and M-Pesa.",
  },
  {
    id: "vid_006",
    title: "African eSports Championship: Grand Finals 2026",
    creatorName: "Helix Gaming",
    creatorHandle: "@helixgaming",
    creatorAvatar: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=150&auto=format&fit=crop&q=80",
    viewsCount: "215.0K views",
    uploadDate: "1 week ago",
    duration: "45:00",
    thumbnailUrl: "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800&auto=format&fit=crop&q=80",
    streamMediaId: "esports-finals-2026",
    hlsManifestUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    category: "Gaming",
    description: "The thrilling final match of the African eSports Championship live from Nairobi Arena.",
  },
  {
    id: "live_kinshasa_session_01",
    title: "LIVE: Kinshasa Sacred Rumba & Sebene Session - Live from Martyrs Arena",
    creatorName: "HP - Helix Creator",
    creatorHandle: "@helixcreator",
    creatorAvatar: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=150&auto=format&fit=crop&q=80",
    channelId: "chn_helixcreator",
    viewsCount: "1.4K watching",
    uploadDate: "Streaming live now",
    duration: "LIVE",
    thumbnailUrl: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&auto=format&fit=crop&q=80",
    streamMediaId: "stream_live_kinshasa_01",
    hlsManifestUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    category: "Music",
    description: "Experience the pulse of Kinshasa live on HP - Helix! Real-time multi-angle streaming, Super Chat fan interactions, and crystal clear edge audio.",
    isLive: true,
    liveViewerCount: 1420,
    rtmpIngestUrl: "rtmps://live.cloudflare.com:443/live/",
    srtIngestUrl: "srt://live.cloudflare.com:10000?streamid=live_kinshasa_session_01",
  },
  {
    id: "vid_kinshasa_360_experience",
    title: "Kinshasa Sunset & Congo River 360° VR Experience",
    creatorName: "HP - Helix Creator",
    creatorHandle: "@helixcreator",
    creatorAvatar: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=150&auto=format&fit=crop&q=80",
    channelId: "chn_helixcreator",
    viewsCount: "54.2K views",
    uploadDate: "1 day ago",
    duration: "6:45",
    thumbnailUrl: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&auto=format&fit=crop&q=80",
    streamMediaId: "kinshasa-360-vr-river",
    hlsManifestUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    category: "Culture & News",
    description: "Immersive 360-degree panoramic virtual tour along the Congo River at sunset. Drag to look in any direction or toggle Cardboard VR mode.",
    is360: true,
    projectionType: "EQUIRECTANGULAR",
    aspectRatio: "16:9",
  },
];
